import React, { useEffect, useState, useCallback, Suspense } from "react";
import { deleteItem, fetchData, toggleStatus } from "../../utils/apiUtils";
import { ToggleSwitch, ViewButton } from "../../helper/ImageFormat";
import debounce from "lodash.debounce";
import Spinner from "../../Components/spinner";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DeleteModel from "../../Components/DeleteModel";
import { formatDate } from "../../utils/constants";
import Breadcrumb from "../../helper/Breadcrumb";
import PerPageSelect from "../../Components/PerPageSelect";
import TableSearch from "../../Components/TableSearch";
import CustomPagination from "../../helper/Pagination";
const Customers = () => {
  const navigator=useNavigate();
 const [loading, setLoading] = useState(true);
 const [customersdata, setCustomersData] = useState([]);
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const [search, setSearch] = useState("");
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [isDeleting, setIsDeleting] = useState(false);
 const [deleteItemId, setDeleteItemId] = useState({});
 const totalPages = Math.ceil(totalCount / perPage);
const fetchCustomersData = useCallback(
  async (page = 1, searchQuery = "") => {
    setLoading(true);
    const requestData = {
      perPage,
      pageNo: page,
      search: searchQuery,
    };

    await fetchData(
      "users-pagination",
      requestData,
      setCustomersData,
      setTotalCount,
      null,
      setLoading
    );
  },
  [perPage]
);



 const debouncedFetchCustomers = useCallback(
  debounce(fetchCustomersData, 500),
  [fetchCustomersData]
 );

 useEffect(() => {
  debouncedFetchCustomers(1, search);
 }, [currentPage, search, debouncedFetchCustomers]);

 const handleStatusToggle = async (item) => {
  const data = await toggleStatus("users-status", item?.id);
  if (Object.keys(data).length > 0) {
   setCustomersData((prev) =>
    prev.map((curr) =>
     curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };
 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem(
    "users",
    deleteItemId?.id,
    debouncedFetchCustomers
   );
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (err) {
   throw err;
  } finally {
   setIsDeleting(false);
  }
 };

 const breadcrumbdata = [
  { label: "Home", path: "/dashboard" },
  { label: "Customers", path: "*" },
 ];

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   setCurrentPage(page);
  }
 };
  const handleRedirect = (id) => {
        navigator(`/customers-detail/${id}`);
    };
 return (
  <div className="content-wrapper">
   <div className="page-header mt-5">
    <h3 className="custom-page-title">Customers</h3>
    <Breadcrumb items={breadcrumbdata} />
   </div>
   <div
    className="d-flex justify-content-between mb-2"
    style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
   >
    <PerPageSelect value={perPage} onChange={setPerPage} />
    <div style={{ display: "flex", gap: "20px" }}>
     <TableSearch value={search} onChange={setSearch} />
    </div>
   </div>

   <div className="row">
    <div className="col-md-12 grid-margin stretch-card">
     <div className="card">
      <div className="card-body">
       <div className="table-responsive">
        <table className="custom-table table table-striped" id="usersTable">
         <thead>
          <tr>
           {[
            "Name",
            "Email",
            "Mobile Number",
            "Customer Type",
            "Join Date",
            "Orders",
            "View",
            "Active",
            "Action"
           ].map((item, index) => (
            <th className="font-weight-bold text-left" key={index}>
             {item}
            </th>
           ))}
          </tr>
         </thead>
         <tbody>
          {loading ? (
           <tr>
            <td colSpan="12" className="text-center">
             <Spinner />
            </td>
           </tr>
          ) : customersdata.length > 0 ? (
           <>
            {customersdata.map((item, index) => (
             <tr key={item.id || index}>
              <td className="text-left">{item?.name}</td>
              <td className="text-left">
               <i
                className="fa-regular fa-envelope"
                style={{ marginRight: "5px", color: "#f44336" }}
               />
               {item?.email}
              </td>
              <td className="text-left">
               <i
                className="fa-solid fa-phone"
                style={{ marginRight: "5px", color: "#4caf50" }}
               />
               {item?.mobile_number}
              </td>
              <td className="text-left">
               <span
                style={{
                 display: "inline-block",
                 padding: "4px 10px",
                 borderRadius: "5px",
                 fontSize: "12px",
                 fontWeight: "600",
                 textTransform: "uppercase",
                 letterSpacing: "0.5px",
                 backgroundColor:
                  item?.type === "WHOLESALE"
                   ? "rgba(59, 130, 246, 0.1)"
                   : "rgba(34, 197, 94, 0.1)",
                 color: item?.type === "WHOLESALE" ? "#1d4ed8" : "#15803d",
                 border:
                  item?.type === "WHOLESALE"
                   ? "1px solid rgba(59, 130, 246, 0.3)"
                   : "1px solid rgba(34, 197, 94, 0.3)",
                }}
               >
                {item?.type === "WHOLESALE" ? "WHOLESALE" : "RETAIL"}
               </span>
              </td>
              <td className="text-left">{formatDate(item?.updatedAt)}</td>
              <td className="text-left">
               <Link to={`order/${item.id}`}>
                <button type="button" className="count-button1">
                 {item._count?.orders}
                </button>
               </Link>
              </td>

               <td>
            <ViewButton handleRedirect={handleRedirect} id={item?.id} />
          </td>
              <td className="text-left">
               <ToggleSwitch
                data={item}
                name="isActive"
                checked={item.isActive}
                handleStatusToggle={handleStatusToggle}
                module={"Customers"}
               />
              </td>
              <td>
               <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="delete-tooltip">Delete</Tooltip>}
               >
                <div
                 style={{
                  background: "rgba(255, 77, 107, 0.1)",
                  padding: "5px",
                  borderRadius: "5px",
                 }}
                >
                 <i
                  className="fa-solid fa-trash-can"
                  onClick={() => handleDelete(item)}
                  style={{
                   cursor: "pointer",
                   color: "rgba(255, 77, 107, 1)",
                   padding: "5px",
                   fontSize: "18px",
                  }}
                 />
                </div>
               </OverlayTrigger>
              </td>
             </tr>
            ))}
           </>
          ) : (
           <tr>
            <td colSpan="12" className="text-center">
             <h5>No data found.</h5>
            </td>
           </tr>
          )}
         </tbody>
        </table>
       </div>
       <div>
        {
          customersdata && customersdata.length > 0 && <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
        }
       </div>
      </div>
     </div>

     <Suspense fallback={<div>Loading...</div>}>
      {deleteModalOpen && (
       <DeleteModel
        deleteModalOpen={deleteModalOpen}
        setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
        onConfirm={confirmDelete}
        itemName="customer ,if customer is deleted then his orders will also be deleted"
        isDeleting={isDeleting}
       />
      )}
     </Suspense>
    </div>
   </div>
  </div>
 );
};

export default Customers;
